import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { smiUrl } from 'components';
import { catchError, Observable, of } from 'rxjs';
import { retryUnlessPlanRefusal } from '@brand-lolly/app/social-media-influencer/modules/social-listening/utils/social-listening-refusal.util';

export interface IndustryListItem {
	id: string;
	topic_name: string;
	status?: string;
	/**
	 * When collection last produced anything, for the header's status block.
	 * Optional because the field is being added to this response separately —
	 * absent, the header says "Not collected yet" rather than nothing at all.
	 */
	last_collected_at?: string | null;
	/**
	 * Why the entity's last collection run collected nothing, when it was
	 * stopped: `entity_budget`, `account_pool`, `credit_balance`,
	 * `free_ceiling` or `daily_allowance`. Null or absent once a run reserves.
	 */
	last_run_stopped_by?: string | null;
}

@Injectable({ providedIn: 'root' })
export class GetSocialListeningIndustryListService {
	constructor(private http: HttpClient) {}

	/**
	 * Lists the user's Social Listening industries. On error returns an
	 * empty array (NOT mock data) so callers can safely use it to decide
	 * whether the user has any industry entity.
	 */
	fetch(): Observable<IndustryListItem[]> {
		return this.read().pipe(catchError(() => of<IndustryListItem[]>([])));
	}

	/**
	 * {@link fetch} without the empty fallback, so the redirect guard can tell
	 * "no industry" from "refused for the plan".
	 */
	read(): Observable<IndustryListItem[]> {
		const url = smiUrl().add('social-listening').add('industry').done();

		// First SL navigation after load can race the auth/subscription
		// context; retry the transient failure before reading it as "no
		// industry" (which would misredirect to industry-setup).
		return this.http
			.get<IndustryListItem[]>(url)
			.pipe(retryUnlessPlanRefusal());
	}
}
